import { ImportProductsXlsxTranslation } from "#i18n/translations/pt-BR/place/products/import-products-xlsx";

export const IMPORT_PRODUCTS_XLSX_EN_US: ImportProductsXlsxTranslation = {
	header: {
		title: "Import products",
		bulkEditTitle: "Bulk edit products",
	},
	layout: {
		importProductsTable: "Import your product table",
		tutorial: "Add one or more products at a time by importing a spreadsheet.",
		bulkEditTutorial: "Edit one or more products at a time through the spreadsheet.",
	},
	form: {
		totalProducts: "Total products",
		successfullyImported: "Products imported",
		productsWithErrors: "Products with errors",
		alert: {
			title: "Products with errors",
			message:
				"We identified some products with incorrect information. Download the spreadsheet with errors, correct the data, and then import again.",
		},
		tooltip: {
			totalProducts: "Your table had {{totalProducts}} products",
			successfullyImported:
				"{{totalProducts}} products have already been successfully added",
			productsWithErrors: "Download the spreadsheet with errors and upload again",
		},
		warning: {
			title: "Warning",
			description: "The product values are entered in cents, ex: 123 equals $1.23",
		},
		importProductsActiveByDefault: "Import products with active status",
	},
	sheet: {
		columns: {
			name: "Name",
			systemProductId: "System Product ID",
			category: "Category",
			menuCategory: "Menu category",
			description: "Description",
			image: "Image (ID)",
			imagePreview: "Image (preview)",
			imageIndex: "Image (index)",
			existingImage: "Original image",
			basicStorageUnit: "Basic storage unit",
			price: "Price",
			priceInCents: "Price in cents",
			bars: "Bars (separated by semicolon)",
			hasAlcohol: "Contains alcohol?",
			isHiddenFromApp: "Do not show product in ZigApp",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - NCM",
			fiscalCest: "Fiscal - CEST",
			fiscalProductGroup: "Fiscal - Fiscal product group",
			fiscalProfile: "Fiscal - Fiscal profile",
			fiscalIcmsBaseCalculoRetSt: "Fiscal - ICMS ST previous calc base (cents)",
			fiscalIcmsValorSubistituto: "Fiscal - ICMS substitute own value (cents)",
			fiscalIcmsAliquotaFinal: "Fiscal - Final rate supported by consumer",
			isStockable: "Stockable",
			beerBrand: "Beer brand",
			beerStyle: "Beer style",
			beerAbv: "ABV - Alcohol by volume",
		},
		sampleFileName: "example_import_products",
		errorFileName: "import_products_with_errors",
		auxiliarSheets: {
			bars: "Bars",
			images: {
				ptBr: "PT-BR",
				esMx: "ES-MX",
				id: "ID",
				url: "URL",
				name: "Images",
			},
		},
	},
	upload: {
		warning: {
			title: "Warning",
			description:
				"Use only the spreadsheet downloaded from this place. Files exported from other places are not accepted.",
		},
	},
	button: {
		continue: "Continue Import",
		validating: "Validating...",
		cancel: "Cancel",
	},
};
